
import {YesNoRadio} from '../define/yesNoRadio';
import {Gender} from '../define/gender'
import {CategoryType} from "../define/categoryType";
import {Injectable} from "@angular/core";
import {FilterType} from "../define/filterType";
import {PlanYearFilter} from "../define/planYearFilter";
import {SortOrder} from "../define/sortOrder";
import {PlanCodeFilter} from "../define/planCodeFilter";
import {AssetsFilter} from "../define/assetsFilter";
import {EmployerFilter} from "../define/employerFilter";
import {BusinessFilter} from "../define/businessFilter";
import {StateFilter} from "../define/stateFilter";
import {ForeignFilter} from "../define/foreignFilter";
import {FormYearFilter} from "../define/formYearFilter";
import {Direction} from "../define/direction";
import {SortColumn} from "../define/sortColumn";

declare var $: any;

@Injectable()
export class StaticsService {
	private yesNoRadio;
	private gender;
	private categoryType;
	private filterType;
	private planYearFilter;
	private sortOrder;
	private planCodeFilter;
	private assetsFilter;
	private employerFilter;
	private businessFilter;
	private stateFilter;
	private foreignFilter;
	private formYearFilter;
	private sortColumn;
	private direction: Direction;

	constructor() {
		this.yesNoRadio = new YesNoRadio();
		this.gender = new Gender();
		this.categoryType = new CategoryType();
		this.filterType = new FilterType();
		this.planYearFilter = new PlanYearFilter();
		this.planCodeFilter = new PlanCodeFilter();
		this.sortOrder = new SortOrder()
		this.assetsFilter = new AssetsFilter();
		this.employerFilter = new EmployerFilter();
		this.businessFilter = new BusinessFilter();
		this.stateFilter = new StateFilter();
		this.foreignFilter = new ForeignFilter();
		this.formYearFilter = new FormYearFilter();
		this.sortColumn = new SortColumn();
		this.direction = new Direction();
	}

	public getSortColumn() : SortColumn {
		return this.sortColumn;
	}

	public getDirection(): Direction {
		return this.direction;
	}

	public getYesNoRadio(): YesNoRadio {
		return this.yesNoRadio;
	}
    
	public getGender(): Gender {
		return this.gender;
	}

	public getCategoryType(): CategoryType {
		return this.categoryType;
	}

	public getFilterType(): FilterType {
		return this.filterType;
	}

	public getPlanYearFilter(): PlanYearFilter {
		return this.planYearFilter;
	}

	public getPlanCodeFilter(): PlanCodeFilter {
		return this.planCodeFilter;
	}

	public getAssetsFilter(): AssetsFilter {
		return this.assetsFilter;
	}

	public getEmployerFilter(): EmployerFilter {
		return this.employerFilter;
	}

	public getBusinessFilter(): BusinessFilter {
		return this.businessFilter;
	}

	public getStateFilter(): StateFilter {
		return this.stateFilter;
	}

	public getForeignFilter(): ForeignFilter {
		return this.foreignFilter;
	}

	public getFormYearFilter(): FormYearFilter {
		return this.formYearFilter;
	}

	public getSortOrder(): SortOrder {
		return this.sortOrder;
	}
}